interface Props {
  message?: string;
  onRetry?: () => void;
}

export function ErrorState({ message = "We couldn't load this report.", onRetry }: Props): JSX.Element {
  return (
    <div className="rounded-lg border border-red-200 bg-red-50 p-4 text-sm text-red-800">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <div className="font-semibold">Something went wrong</div>
          <div className="mt-1 text-red-700">{message}</div>
        </div>
        {onRetry && (
          <button type="button" className="btn-secondary border-red-300 bg-white text-red-700 hover:bg-red-100" onClick={onRetry}>
            Retry
          </button>
        )}
      </div>
    </div>
  );
}
